/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.donations.config.list.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.userPreferences',
  'acme.view.application.donations.config.createModal.controllers',
  'acme.view.application.donations.config.removeModal.controllers'
])

.controller('DonationsConfigListController', [
  '$scope', '$state','$uibModal', '$timeout', 'ApiService', 'HelpersService', 'NoticeFactory', 'PermissionsService', 'GridStateFactory', 'GridDefinitionFactory',
  function($scope, $state, $uibModal, $timeout, ApiService, HelpersService, NoticeFactory, PermissionsService, GridStateFactory, GridDefinitionFactory) {

    $scope.donationsConfigList = {

      model: [],

      currentType: '',

      hasDefault: false,
      defaultItem: {},

      type: [
        'campaigns',
        'appeals',
        'funds'
      ],

      viewId: '',
      donationsConfigGridName: $state.current.name+'.grid0',

      modal: {},

      notice: new NoticeFactory(),
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),

      optionsOverride: {
        useAccessibleGrid: true,
        data: 'donationsConfigList.model',
        columnDefs: [
          {
            field: 'id',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            sort: {
              direction: 'asc'
            }
          },
          {
            field: 'description',
            displayName: 'Description',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html'
          },
          {
            field: 'isDefault',
            displayName: 'Default',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if (param.node.data.isDefault) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          },
          {
            field: 'online',
            displayName: 'Web',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if (param.node.data.online) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          },
          {
            field: 'pos',
            displayName: 'POS',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if (param.node.data.pos) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          },
          {
            field: 'csr',
            displayName: 'Customer Rep.',
            cellTemplate: '<div data-ng-class="\'colt\' + col.index" class="grid-input-cell"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div>',
            cellRenderer: function(param) {
              var r = '';
              if (param.node.data.csr) {
                r = 'Yes';
              } else {
                r = 'No';
              }
              return r;
            }
          }
        ],
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.donationsConfigList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
            $scope.donationsConfigList.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function (item) {
            $scope.donationsConfigList.onDblClick(item);
          },
          edit: function (item) {
            $scope.donationsConfigList.edit(item);
          },
          remove: function(item) {
            $scope.donationsConfigList.remove(item);
          }
        }
      },

      init: function () {

        this.currentType = $state.params.type || this.type[0];

        $scope.$emit('Application::contentTitleChange', {
          title: 'Config',
          buttonRight: {
            permissions: 'DONATIONS_CONFIG_CREATE',
            label: '+ Add ' + HelpersService.cap(this.currentType),
            opensDialog: true,
            action: function() {
              $scope.donationsConfigList.create();
            }
          }
        });

        if (PermissionsService.check('DONATIONS_CONFIG_DELETE')) {
          this.optionsOverride.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            onCellNavClick: function(row, col) {
              $scope.donationsConfigList.optionsOverride.appScopeProvider.remove(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('DONATIONS_CONFIG_UPDATE')) {
          this.optionsOverride.columnDefs.unshift({
            field: 'editable',
            displayName: 'Edit',
            width: 60,
            onCellNavClick: function(row, col) {
              $scope.donationsConfigList.optionsOverride.appScopeProvider.edit(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.edit(row.entity)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>'
          });
        }

        this.viewId = $state.current.name;
        this.gridDefinition.init(this.donationsConfigGridName, this.optionsOverride, this.viewId, $state.current.data.enablePreferences);

        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));

      },

      initData: function (e, data) {
        var self = $scope.donationsConfigList, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        $scope.donationsConfigList.getConfigItemList();
      },

      getConfigItemList: function () {
        var self = $scope.donationsConfigList;
        ApiService.donations.list(self.currentType, self.gridState.getGridState()).then(self.success.getConfigItemList, self.error.getConfigItemList);
      },

      create: function () {
        var self = $scope.donationsConfigList;

        self.modal = $uibModal.open({
          templateUrl: 'views/application/views/donations/config/list/modals/createConfig.tpl.html',
          size: 'md',
          controller: 'DonationsConfigCreateModalController',
          resolve: {
            currentType: function() {
              return self.currentType.slice(0, -1);
            },
            list: function() {
              return self.model;
            },
            currentItem: function() {
              return false;
            }
          }
        });

        self.modal.result.then(function (item) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          if (item.isDefault && self.hasDefault && item.id !== self.defaultItem.id) {
            self.updateDefault();
          }

          ApiService.donations.create(self.currentType, item).then(self.success.create, self.error.create);
        }, function () {
          // Do nothing
        });
      },

      edit: function (item) {
        var self = $scope.donationsConfigList;

        self.modal = $uibModal.open({
          templateUrl: 'views/application/views/donations/config/list/modals/createConfig.tpl.html',
          size: 'md',
          controller: 'DonationsConfigCreateModalController',
          resolve: {
            currentType: function() {
              return self.currentType.slice(0, -1);
            },
            list: function() {
              return self.model;
            },
            currentItem: function() {
              return item;
            }
          }
        });

        self.modal.result.then(function (item) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          if (item.isDefault && self.hasDefault && item.id !== self.defaultItem.id) {
            self.updateDefault();
          }

          ApiService.donations.update(self.currentType, item).then(self.success.update, self.error.update);
        }, function () {
          // Do nothing
        });
      },

      remove: function(item) {
        var self = $scope.donationsConfigList;

        self.modal = $uibModal.open({
          templateUrl: 'views/application/views/donations/config/list/modals/removeConfig.tpl.html',
          size: 'md',
          controller: 'DonationsConfigRemoveModalController',
          resolve: {
            currentType: function() {
              return self.currentType.slice(0, -1);
            },
            currentItem: function() {
              return item;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.modal.result.then(function () {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          ApiService.donations.remove(self.currentType, item.id).then(self.success.remove, self.error.remove);
        }, function () {
          // Do nothing
        });
      },

      updateDefault: function () {
        var self = $scope.donationsConfigList;
        self.defaultItem.isDefault = false;
        ApiService.donations.update(self.currentType, self.defaultItem).then(self.success.updateDefault, self.error.updateDefault);
      },

      isTabActive: function (value) {
        return (value === this.currentType);
      },

      success: {
        init: function (response) {},
        getConfigItemList: function (response) {
          var self = $scope.donationsConfigList;
          self.model = response.data.payload.list;
          self.gridDefinition.isLoaded = true;

          self.hasDefault = false;
          angular.forEach(self.model, function(item, index) {
            if (item.isDefault) {
              self.hasDefault = true;
              self.defaultItem = item;
            }
          });

          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: response.data.payload.pagination.count});
          }, 10);
        },
        create: function (response) {
          $scope.donationsConfigList.getConfigItemList();
        },
        update: function (response) {
          $scope.donationsConfigList.getConfigItemList();
        },
        remove: function (response) {
          $scope.donationsConfigList.getConfigItemList();
        },
        updateDefault: function (response) {}
      },

      error: {
        init: function (response) {},
        getConfigItemList: function (response) {},
        create: function (response) {},
        update: function (response) {},
        remove: function (response) {},
        updateDefault: function (response) {}
      },

      onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
        var self = $scope.donationsConfigList;
        self.gridState.updateGridState(newPage, pageSize);
        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if(sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.getConfigItemList();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.donationsConfigList, data = columns[0];
        self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        self.getConfigItemList();
      },

      onDblClick: function(item) {
        var self = $scope.donationsConfigList;
        $scope.donationsAmountList.edit(item);
      }

    };

    $scope.donationsConfigList.init();

}]);
